<template>
  <Photo :currentConstruction="currentConstruction" :suggestWords="suggestWords" />
</template>

<script>
import store from '@/store'

export default {
  name: 'PhotoList',
  components: {
    Photo: () => import('../../../components/cloud/CreKokuban/ConstructionFolder/Photo.vue')
  },
  props: {
    currentConstruction: Object
  },
  computed: {
    suggestWords(){
      return this.$store.getters['api/result/wordList']
    } 
  },
  beforeRouteEnter(to, from, next) {
    // 検索候補文字列取得
    const args = {
      cloud_construction_id: to.params.cloudConstructionId
    };
    store.dispatch('api/getKokubanSuggestWordList', args).then(() => {
      if (store.getters['api/apiError']) {
        next(false);
        return;
      }
      next();
    });
  }
}
</script>

<style scoped>
</style>